import React from 'react'

export default function index() {
    return (
        <section>
            <h1>Experience</h1>

            <h2>Instituto Mexicano del Seguro Social</h2>

            <h3>Emergency medicine doctor</h3>

            <h4>March 2014 — October 2021</h4>

            <p>Medical attention in an emergency room.</p>
            <p>Provided thorough pysical evaluations of patients.</p>
            <p>Work team with nurses, radiological personal and others doctors.</p>
            <p>Provide a medical report to family members.</p>
        </section>
    )
}
